// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"index_pageContainer_21xjV","pageTitle":"index_pageTitle_1LgUR"};